/* eslint-disable react/no-unused-prop-types */
import classNames from "classnames";
import { useInView } from "react-cool-inview";
import { useState } from "react";

// Components
import Button from "components/atoms/Button";

// Containers
import GameCardContainer from "containers/molecules/GameCardContainer";

// Hooks
import { useBreakpoint } from "hooks/useBreakpoint";

// Types
import { GameType, NewHistoryResponseType } from "types/Games";

import "./styles.sass";

type GameListProps = {
  isAutoLoading: boolean;
  list: GameType[] | null | NewHistoryResponseType[];
  take: number | null;
  page?: number;
  lastPage?: number;
  isLoading: boolean;
  isOverlayLoading: boolean;
  tournamentId?: string;
  onShowMore?: () => void;
};

const GameList = (props: GameListProps) => {
  const {
    list,
    isAutoLoading = true,
    page,
    lastPage,
    tournamentId,
    onShowMore,
  } = props;

  const { isTabletAndLess } = useBreakpoint();

  const [isShowMoreClicked, setIsShowMoreClicked] = useState(false);

  const { VITE_APP_PROJECT_NAME } = import.meta.env;

  const variationType =
    VITE_APP_PROJECT_NAME === "glory" ? "glory-gradient" : "banger-gradient";

  const gameListClass = classNames("GameList__list", {
    // eslint-disable-next-line camelcase
    GameList__list_tournament: tournamentId,
  });

  const handleShowMore = () => {
    setIsShowMoreClicked(true);
    if (onShowMore) {
      onShowMore();
    }
  };

  const { observe } = useInView({
    threshold: 0.25,
    rootMargin: isTabletAndLess ? "-50px" : "-150px",
    onEnter: () => {
      if (isAutoLoading && onShowMore && isShowMoreClicked) {
        handleShowMore();
      }
    },
  });

  if (!list?.length) {
    return null;
  }

  return (
    <div className="GameList">
      <div className={gameListClass}>
        {list.map((game, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <GameCardContainer key={game.uuid + index} game={game} />
        ))}
      </div>
      {page && lastPage && page !== lastPage && !!list.length ? (
        <div className="GameList__more" ref={observe}>
          {/* {!isShowMoreClicked ? ( */}
          <Button
            label="casino.lobby.more"
            variation={!tournamentId ? "primary" : `${variationType}`}
            onClick={handleShowMore}
          />
          {/* ) : null} */}
        </div>
      ) : null}
    </div>
  );
};

export default GameList;
